export default {
  methods: {
    supplierHaveProduct() {
      return (
        this.contract.supplier_products &&
        this.contract.supplier_products.length > 0
      );
    },
    canGenerateScore(previsional) {
      return (
        this.contractHaveProductTrades(previsional) &&
        // this.netWeightAreEquals(previsional) &&
        this.netWeightAreNotNull(previsional)
      );
    },
    netWeightAreEquals() {
      return this.getNetWeightProducts() === this.getNetWeightExpeditions();
    },
    netWeightAreNotNull() {
      return (
        this.getNetWeightProducts() > 0 && this.getNetWeightExpeditions() > 0
      );
    },
    contractHaveProductTrades() {
      const key = this.previsional ? "product_trades" : "real_product_trades";
      const length = this.contract[key].length;
      return length > 0 && this.contract[key][length - 1].id !== "new";
    },
    getNetWeightProducts() {
      const key = this.previsional ? "product_trades" : "real_product_trades";
      var nw = 0;
      for (var i = 0; i < this.contract[key].length; i++) {
        if (this.contract[key][i].id === "new") continue;
        nw += this.contract[key][i].net_weight;
      }
      return Math.round(10000 * nw) / 10000;
    },
    getNetWeightExpeditions() {
      const expeditions = this.previsional
        ? this.previsional_expeditions
        : this.real_expeditions;
      var nw = 0;

      for (var i = 0; i < expeditions.length; i++) {
        if (expeditions[i].id === "new") continue;
        nw += expeditions[i].net_weight * expeditions[i].quantity;
      }
      return Math.round(10000 * nw) / 10000;
    }
  }
};
